import axiosInstance from "./axiosInstance";

const ContactAPI = {
    getDetailContact: () => {
        try {
            return axiosInstance.get("/contactoffice.json");
        } catch (error) {
            console.error("ContactAPI.getDetailContact", error);
            return null;
        }
    },
    getDetailContactEn: () => {
        try {
            return axiosInstance.get("/en/contactoffice.json");
        } catch (error) {
            console.error("ContactAPI.getDetailContact", error);
            return null;
        }
    },

    getContactFAQ: () => {
        try {
            return axiosInstance.get("/faq.json");
        } catch (error) {
            console.error("ContactAPI.getContactFAQ", error);
            return null;
        }
    },
    getContactFAQEn: () => {
        try {
            return axiosInstance.get("/en/faq.json");
        } catch (error) {
            console.error("ContactAPI.getContactFAQ", error);
            return null;
        }
    },

    getContractComplaint: () => {
        try {
            return axiosInstance.get("/contactcomplaint.json");
        } catch (error) {
            console.error("ContactAPI.getContractComplaint", error);
            return null;
        }
    },
    getContractComplaintEn: () => {
        try {
            return axiosInstance.get("/en/contactcomplaint.json");
        } catch (error) {
            console.error("ContactAPI.getContractComplaint", error);
            return null;
        }
    }
};

export default ContactAPI;
